import React from "react";
import { useOffline } from "./OfflineProvider";

// Dims its children and shows a ribbon while offline. Children stay mounted
// so their state survives a short disconnect.
export default function OnlineOnly({ children, message = "Nur online verfügbar" }) {
  const { isOnline } = useOffline();
  if (isOnline) return children;
  return (
    <div className="online-only is-offline" aria-disabled="true">
      <div className="online-only-ribbon">{message}</div>
      <div className="online-only-content">{children}</div>
    </div>
  );
}
